import { useLocalStorage } from 'usehooks-ts'

import { useAuth } from 'src/auth'
import { useCurrentBreakpoint } from 'src/hooks/use-current-breakpoint'
import { LocalStorageKey } from 'src/types'

export enum LayoutMode {
  Topbar,
  Sidebar,
  SidebarCollapsed,
}

export const useSidebarLayoutMode = () => {
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useLocalStorage(
    LocalStorageKey.SidebarIsCollapsed,
    false
  )

  const { isAuthenticated } = useAuth()
  const { isSmallScreen } = useCurrentBreakpoint()

  const layoutMode =
    isSmallScreen() || !isAuthenticated
      ? LayoutMode.Topbar
      : isSidebarCollapsed
        ? LayoutMode.SidebarCollapsed
        : LayoutMode.Sidebar

  return { isSidebarCollapsed, layoutMode, setIsSidebarCollapsed }
}
